module.exports = "//public.zight.com/packs/media/images/onboarding/download-arrow-5870d7da9eb9c7794df5a1cb9b573784.svg";